export interface StandaloneLocation {
  hash: string;
  hostname: string;
  pathname: string;
  protocol: string;
  search: string;
}

export function standaloneShellURL(
  appSlug: string,
  location: StandaloneLocation,
  configuredShellBaseURL?: string,
): string {
  const shell = new URL(
    configuredShellBaseURL?.trim() || inferredShellOrigin(location),
  );
  const suffix =
    location.pathname === "/"
      ? ""
      : location.pathname.startsWith("/")
        ? location.pathname
        : `/${location.pathname}`;
  shell.pathname = `/open/${encodeURIComponent(appSlug)}${suffix}`;
  shell.search = location.search;
  shell.hash = location.hash;
  return shell.toString();
}

export function redirectToStandaloneShell(
  appSlug: string,
  location: StandaloneLocation & { replace(url: string): void },
  configuredShellBaseURL?: string,
): void {
  location.replace(
    standaloneShellURL(appSlug, location, configuredShellBaseURL),
  );
}

function inferredShellOrigin(location: StandaloneLocation): string {
  const hostname = location.hostname.toLowerCase();
  if (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname === "[::1]"
  ) {
    return `${location.protocol}//${location.hostname}:5173`;
  }
  const labels = hostname.split(".");
  if (labels.length < 2) {
    throw new Error("VITE_SHELL_BASE_URL is required for this host");
  }
  labels[0] = "app";
  return `${location.protocol}//${labels.join(".")}`;
}
